<template>
  <a-modal
    ref="createModal"
    title="属性定义"
    :width="640"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form
      ref="ruleForm"
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item v-for="(item) in attributeList" :key="item.key" :label="item.tblAttribute" :prop="item.tblAttribute">
        <a-input v-model="item.tblValue" :placeholder="`请输入${item.tblAttribute}`" />
        <a-input v-model="item.label" :placeholder="`请输入${item.tblAttribute}提示`" class="ml10" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { apiLookupAttributeList, apiLookupAttributeUpdate } from '@/api/system/lookup/type'
// 表单字段
export default {
  props: {},
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      // readOnly: false,
      visible: false,
      // 表单参数
      form: {},
      labelCol: {
        xs: { span: 12 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      id: "",
      attributeList: []
    }
  },
  created () {},
  methods: {
    getAttribute () {
      const params = {
        lookupTypeId: this.id,
        pageNum: 1,
        pageSize: 100
      }
      apiLookupAttributeList(params).then(res => {
        if (res.code === 200 && res.rows && res.rows.length > 0) {
          this.attributeList = res.rows
        }
      })
    },
    // 由于要用传进来的值做判断,将显示和隐藏放在内部做处理
    show (data) {
      this.id = data.id
      this.getAttribute()
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.visible = false
    },
    // 保存
    confirm () {
      this.confirmLoading = true
      apiLookupAttributeUpdate(this.attributeList).then(response => {
        if (response.code === 200) {
          this.$message.success('修改成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
input{
  width: 195px;
}
.ml10{
  margin-left: 10px;
}
</style>
